export default "__VITE_ASSET__CX9K$F$z__"